import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"

import { Container, Section } from "@atoms/layout"
import { Heading } from "@atoms/typography"
import CardPost from "@molecules/cards/post"
import Pagination from "@molecules/pagination"
import SEO from "@seo/seo"
import { media } from "@utils/media"
import Layout from "@utils/layout"

const TemplatePostAll = ({ data, pageContext }) => {
  const { entries } = data.craft
  return (
    <Layout>
      <SEO title="All Posts" />
      <Section xlTop>
        <Container lg>
          <Heading html="h1" level="huge" center>
            All Posts
          </Heading>
        </Container>
        <Posts grid md>
          {entries.map((post, index) => (
            <CardPost post={post} key={index} />
          ))}
        </Posts>
        <Pagination pageContext={pageContext} />
      </Section>
    </Layout>
  )
}

export default TemplatePostAll

const Posts = styled(Container)`
  ${media.sm`
    grid-template-columns: repeat(6, 1fr);

    article {
      grid-column: auto / span 2;
      &:nth-child(-n + 2) {
        grid-column: auto / span 3;
      }
    }
  `}
`

export const fetchPostAll = graphql`
  query fetchPostAll($skip: Int!, $limit: Int!) {
    craft {
      entries(offset: $skip, limit: $limit) {
        ...CardPost
      }
    }
  }
`
